import { RECENT_SEARCHES } from './../types/Index';

const initialState = {
    data: [],
};

export default function RecentSearchReducer(state = initialState, action) {

    switch(action.type) {

        case RECENT_SEARCHES: 

            return {

                ...state,

                data: action.payload,

            };

        default:

            return state;

    }

};